import React from "react"
import { graphql } from "gatsby"
import moment from "moment"
import SEO from "../components/seo"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import Layout from "../components/Layout"
class TagRoute extends React.Component {
  render() {
    const posts = this.props.data.allMarkdownRemark.edges

    const postLinks = posts.map((post) => {
      let coverImage =
        "https://res.cloudinary.com/controlgap/image/upload/w_700,q_auto,f_auto/blog-images/controlgap-wall.jpg"
      if (post.node.frontmatter.coverImage) {
        coverImage = post.node.frontmatter.coverImage
      }
      return (
        <div key={post.node.frontmatter.slug} className="blog-card">
          <div className="blog-head">
            <div className="tags">
              {post.node.frontmatter.tags.map((tag) => (
                <AniLink className="tag" fade to={`/tags/${tag}/`} key={tag}>
                  {tag}
                </AniLink>
              ))}
            </div>
            <h4>
              <AniLink fade to={`/blog/${post.node.frontmatter.slug}`}>
                {post.node.frontmatter.title}
              </AniLink>
            </h4>
            <span className="date">
              {moment(post.node.frontmatter.date).format("DD-MMM-YYYY")}
            </span>
            <p>{post.node.excerpt}</p>
            <AniLink
              className="read-more"
              fade
              to={`/blog/${post.node.frontmatter.slug}`}
            >
              Read More >
            </AniLink>
          </div>
          <AniLink
            className="blog-image-link"
            fade
            to={`/blog/${post.node.frontmatter.slug}`}
            style={{
              backgroundImage: `url(${coverImage})`,
            }}
          ></AniLink>
        </div>
      )
    })

    const tag = this.props.pageContext.tag
    const totalCount = this.props.data.allMarkdownRemark.totalCount
    const tagHeader = `${totalCount} post${
      totalCount === 1 ? "" : "s"
    } tagged with “${tag}”`

    return (
      <Layout>
        <SEO title="Contact Us | Get secure now" />
        <div className="hero blog-hero hero-text-center">
          <div>
            <h1 style={{ textTransform: "capitalize" }}>{tag}</h1>
            <h3>{tagHeader}</h3>
          </div>
        </div>
        <div
          style={{
            background:
              "linear-gradient(103deg, rgb(255, 255, 255) 0%, rgb(205, 205, 205) 100%)",
          }}
        >
          <div className="container">
            <div className="blog-container">{postLinks}</div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default TagRoute

export const tagPageQuery = graphql`
  query TagPage($tag: String) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: {
        fileAbsolutePath: { regex: "/content/blog/" }
        frontmatter: { tags: { in: [$tag] } }
      }
    ) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            coverImage
            title
            date
            slug
            tags
          }
        }
      }
    }
  }
`
